import { asText } from '@prismicio/helpers';
import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { TwoStepForm } from 'remote-com-shared/components/TwoStepForm';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import { fieldHasContent } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { Section } from './OverviewSlice';
import Illustration from './assets/offer-left.svg';

import { transformProperties } from '@/src/domains/prismic/helpers';
import { desktopBreakpoint } from '@/src/domains/shared/breakpoints';
import { ApplyFormColumn } from '@/src/views/DownloadableResources/OverviewFormSlice';

export const SectionWrapper = styled(Section)`
  --primaryColor: #5700ff;

  background: #f8f5ff;
  font-family: var(--typography-fontBrand);
  ${fluidProp(['padding-bottom', 'padding-top'], '50px', '80px')}

  ${ContentContainer} {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${desktopBreakpoint(css`
      flex-direction: column;
    `)};
  }

  ${ApplyFormColumn} {
    width: 467px;
  }
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.scale3}
  font-family: var(--typography-fontBossa);
  margin-bottom: 24px;
  color: var(--primaryColor);

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const Description = styled.div`
  ${({ theme }) => theme.typography.bodyLead}
  color: var(--colors-darkBlue);

  ul,
  ol {
    margin-top: 46px;
    list-style-type: none;
    padding-left: 30px;

    li {
      margin-top: 21px;
      position: relative;
      padding-left: 10px;

      &::before {
        content: '';
        background: ${({ theme }) => theme.colors.blank_75};
        border-radius: 50px;
        top: 5px;
        left: -30px;
        width: 22px;
        height: 22px;
        position: absolute;
        z-index: 2;
      }

      &::after {
        content: '';
        background-color: var(--primaryColor);
        -webkit-mask-image: url(${staticAssetUrl('/images/check-purple.svg')});
        top: 11px;
        left: -26px;
        width: 15px;
        height: 10px;
        position: absolute;
        z-index: 2;
      }
    }
  }
`;

export const ContentWrapper = styled.div`
  width: 40%;

  ${desktopBreakpoint(css`
    width: 90%;
    margin-bottom: 50px;
  `)};
`;

export const IllustrationWrapper = styled.div`
  position: absolute;
  top: -15%;
  left: -5%;
  display: flex;
  z-index: 0;

  ${desktopBreakpoint(css`
    display: none;
  `)}
`;

export function SpecialOfferSlice({ slice }) {
  const { primary, context } = transformProperties(slice);
  const { title, description } = primary;
  const { hubspotFormDefinition, formTitle, formDescription, formButtonLabel } = context;

  return (
    <SectionWrapper id="special-offer">
      <ContentContainer>
        <ContentWrapper>
          {fieldHasContent(title) && (
            <Title>
              <PrismicRichText field={title} />
            </Title>
          )}
          {fieldHasContent(description) && (
            <Description>
              <PrismicRichText field={description} />
            </Description>
          )}
        </ContentWrapper>
        <ApplyFormColumn>
          <TwoStepForm
            formTitle={formTitle}
            formDescription={asText(formDescription)}
            hubspotFormDefinition={hubspotFormDefinition}
            buttonLabel={formButtonLabel}
            companyEmailAddressesOnly
          />
        </ApplyFormColumn>
      </ContentContainer>
      <IllustrationWrapper>
        <Illustration />
      </IllustrationWrapper>
    </SectionWrapper>
  );
}
